<div class=" w-full h-full overflow-hidden">
    <div class="flex flex-col">
        <div class="flex justify-between mb-1">
            <h3 class="site-name-color">{{dashboardService.translate('Select Inventory')}} </h3>
            <span class="flex items-center " mat-dialog-close mat-icon-button style="cursor: pointer">
                <mat-icon [svgIcon]="'custom:close'"></mat-icon>
            </span>
        </div>
    </div>
    <hr class="w-full my-2">
    <!-- //configuration files-->
    <div class="day-night-wrapper" *ngIf="!isMaster && displayDayNightToggle">
        <span class="day-night-label">{{dashboardService.translate('DAY')}}</span>
        <div class="day-night-track">
            <span class="shoulder-btn cursor-pointer" (click)="onDayClick()"></span>
            <span class="center-combined-shoulder-median" (click)="onDayAndNightClick()"></span>
            <span class="median-btn cursor-pointer" (click)="onNightClick()"></span>
            <span *ngIf="isWorkorder" class="center-bg" [id]="'centerbg-110'"></span>
            <span *ngIf="!isWorkorder" class="center-bg" [id]="'centerbg-10'"></span>
        </div>
        <span class="day-night-label">{{dashboardService.translate('NIGHT')}}</span>
    </div>
    <div class="flex flex-col h-3/4 w-full relative">
        <mat-form-field class="flex-auto gt-xs:pr-3 m-0 mb-0 max-h-15 w-full">
            <input matInput class="w-full" [placeholder]="dashboardService.translate('Search Filter')+'...'"
                (input)="onSearchFilter($event.target.value)">
            <mat-icon class="icon-size-5" matSuffix [svgIcon]="'heroicons_solid:search'"></mat-icon>
        </mat-form-field>

        <div class="flex w-full">
            <div class="w-full flex flex-row">
                <div *ngIf="displayIssueType" class="w-1/3">
                    <div class="py-2 pl-5 w-full font-medium">{{dashboardService.translate('Issue')}}</div>
                    <mat-checkbox class="py-2 pl-5 w-full"
                        (change)="onSelectAllIssueTypesClick($event.checked)">{{dashboardService.translate('Select
                        All')}}</mat-checkbox>
                </div>
                <div [ngClass]="displayIssueType ? 'w-1/3' : 'w-1/2'">
                    <div class="py-2 pl-5 w-full font-medium">{{dashboardService.translate('Department')}}
                    </div>
                    <mat-checkbox class="py-2 pl-5 w-full"
                        (change)="onSelectAllAssetTypesClick($event.checked)">{{dashboardService.translate('Select
                        All')}}</mat-checkbox>
                </div>
                <div [ngClass]="displayIssueType ? 'w-1/3' : 'w-1/2'">
                    <div class="py-2 pl-5 w-full font-medium">{{dashboardService.translate('Asset')}}</div>
                    <mat-checkbox class="py-2 pl-5 w-full"
                        (change)="onSelectAllAssetsClick($event.checked)">{{dashboardService.translate('Select
                        All')}}
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div class="flex justify-center flex-row w-full h-[93%]" style="min-height: calc(100vh - 560px) !important;">
            <div class="w-full flex flex-col ">
                <div class="relative sm:max-h-120 divide-y overflow-hidden bg-card w-full h-full">
                    <div class="text-center w-full py-2 pt-0"
                        *ngIf="(!filters || !filters.length) && (!issueTypeData || !issueTypeData.length)">
                        <h3>No Filters Available.</h3>
                    </div>
                    <div class="flex flex-row border-t-2 w-full h-full"
                        *ngIf="(filters && filters.length) || (issueTypeData && issueTypeData.length)">

                        <!-- Issue Type Column -->
                        <div *ngIf="displayIssueType" class="w-1/3 border-r-2 h-full overflow-auto">
                            <div class="flex flex-col w-full">
                                <div class="w-full flex flex-col">
                                    <mat-checkbox class="py-2 pl-5 w-full border-b-2" *ngFor="let data of issueTypeData"
                                        [checked]="isCheckedIssueType(data)" (change)="onIssueTypeClick(data)">
                                        {{ data }}
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>

                        <!-- Asset Type Column -->
                        <div class="border-r-2 h-full" [ngClass]="displayIssueType ? 'w-1/3' : 'w-1/2'">
                            <div class=" flex flex-col w-full">
                                <div class="w-full flex flex-col">
                                    <span class="text-md py-2 border-b-2 pl-5  w-full "
                                        [ngClass]="selectedAssetType && assetType && selectedAssetType.asset_type_name ==assetType.asset_type_name?'bg-hover':''"
                                        *ngFor="let assetType of filters">
                                        <mat-checkbox [checked]="isAssetTypeChecked(assetType)"
                                            (change)="onAssetTypeClick(assetType,$event.checked)"></mat-checkbox>
                                        <span (click)="onAssetClick(assetType)"
                                            class="w-full cursor-pointer">{{displayAssetTypeName(assetType.asset_type_name)
                                            | uppercase}}
                                            <div *ngIf="assetType.selected_asset_count > 0" class="count-border">
                                                <span class="selection-count">
                                                    {{assetType.selected_asset_count}}
                                                </span>
                                            </div>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Assets Column -->
                        <div class="overflow-auto"
                            [ngClass]="(displayIssueType ? 'w-1/3' : 'w-1/2') + ' ' + (isMaster ? 'full-height' : 'min-height')">
                            <div class=" flex flex-col ">
                                <div class="w-full" *ngIf=" selectedAssetType" style="transition: 0.6s">
                                    <mat-checkbox class="py-2 pl-5 w-full" (change)="onSelectFilterChange($event,asset)"
                                        [checked]="isChecked(asset)" *ngFor="let asset of selectedAssetType.assets">
                                        {{dashboardService.translate(asset.asset_name.replace('_', ' '))}}
                                        <!-- <span class="text-xs" style="color: #808080 !important;">({{asset.asset_name.replace('_', ' ')}})</span> -->
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class=" mb-4 mt-3 mr-4 flex justify-end">
                    <button (click)="onSubmitClick()"
                        class="bg-[#142653] hover:bg-[#0e1836] text-white font-bold py-2 px-4 rounded">
                        {{dashboardService.translate('Apply')}}
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>